import { PartnerStatus, ProductInterest, UseCase } from 'modules/data/domain';

export interface PreAhaMomentProps {
    answerAboutGL: PartnerStatus | ProductInterest;
    useCases: UseCase[];
    onNext?: () => void;
}

export enum PreAhaPath {
    Path1 = 'Path1',
    Path2 = 'Path2',
    Path3 = 'Path3',
}

export enum TypeOfGL {
    Xero = 'Xero',
    QuickBooks = 'QuickBooks',
    NetSuite = 'NetSuite',
    Cin7 = 'Cin7',
    Other = 'Other',
}
